import { Link } from 'react-router-dom';

export default function CarsUnder10kHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-50 via-white to-amber-50/30 pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-[#1A2332]/10 text-[#1A2332] px-4 py-2 rounded-full text-sm font-medium mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-money-dollar-circle-line text-base"></i>
            </div>
            Budget-Friendly Options
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-[#1A2332] mb-6 leading-tight">
            Quality Cars Under $10k
            <span className="block text-[#E8B84B]">No Junk. No Games.</span>
          </h1>
          
          <p className="text-xl text-slate-700 mb-8 leading-relaxed">
            Affordable doesn't mean unreliable. Every car under $10k is inspected, 
            reconditioned, and backed by our 30-day warranty. Plus our $250 flat doc fee 
            means more car for your money.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link
              to="/inventory?maxPrice=10000"
              className="inline-flex items-center justify-center px-8 py-4 bg-[#E8B84B] text-white rounded-lg font-semibold hover:bg-[#D4A43A] transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Browse Cars Under $10k
            </Link>
            <Link
              to="/apply-for-financing"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#1A2332] rounded-lg font-semibold hover:bg-slate-50 transition-all border-2 border-[#1A2332] whitespace-nowrap"
            >
              Get Pre-Approved
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
              <div className="w-12 h-12 bg-[#1A2332]/10 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className="ri-shield-check-line text-2xl text-[#1A2332]"></i>
              </div>
              <h3 className="font-bold text-[#1A2332] mb-2">30-Day Warranty</h3>
              <p className="text-sm text-slate-700">
                Every car comes with a 30-day/1,000-mile warranty. No "as-is" surprises.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
              <div className="w-12 h-12 bg-[#E8B84B]/10 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className="ri-price-tag-3-line text-2xl text-[#E8B84B]"></i>
              </div>
              <h3 className="font-bold text-[#1A2332] mb-2">$250 Flat Doc Fee</h3>
              <p className="text-sm text-slate-700">
                Most dealers charge $500-$800. We charge $250. That's hundreds back in your pocket.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
              <div className="w-12 h-12 bg-[#1A2332]/10 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className="ri-bank-card-line text-2xl text-[#1A2332]"></i>
              </div>
              <h3 className="font-bold text-[#1A2332] mb-2">Financing Available</h3>
              <p className="text-sm text-slate-700">
                Bad credit? First-time buyer? We work with lenders who specialize in budget-friendly financing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
